import { useSelector } from "react-redux";

const useAttractions = () => {
    const attractions = useSelector((state) => state.attractions);
    return attractions;
};

export default useAttractions;